import httpClient from '../httpClient';

const filter = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
  _exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;
  return await httpClient.get(
    `/mass_contract_modifications/${query}&page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
  );
};

const get = async (id) => {
  return await httpClient.get(`/mass_contract_modifications/${id}/`);
};

const remove = async (id) => {
  return await httpClient.delete(`/mass_contract_modifications/${id}/`);
};

const getCounters = async (projectId) => {
  return await httpClient.get(
    `/mass_contract_modifications/counters/?filter[proyecto]=${projectId}`,
  );
};

const getNewInfo = async (projectId) => {
  return await httpClient.get(`/contract_modifications/${projectId}/new_info/`);
};

const massContractSearch = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/mass_contract_search/export/?${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/mass_contract_search/?page[number]=${page}&page[size]=${pageSize}&${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const getTermsSelector = async (cargo) => {
  return await httpClient.get(`mass_ctm_term_selector/?filter[cargo]=${cargo}`);
};

const getIdentifierSelector = async (term) => {
  return await httpClient.get(`mass_ctm_ctm_selector/?filter[termino]=${term}`);
};

const getIMInfo = async (query) => {
  return await httpClient.get(`/mass_contract_search/im_info/?${query}`);
};

const massContractSearchPayments = async (query = '') => {
  return await httpClient.get(`/mass_contract_search_payments/?${query}`);
};

const massContractSearchProducts = async (query = '') => {
  return await httpClient.get(`/mass_contract_search_products/?${query}`);
};

const post = async (data) => {
  return await httpClient.post('/mass_contract_modifications/', data);
};

const patch = async (id, data) => {
  return await httpClient.patch(`/mass_contract_modifications/${id}/`, data);
};

const getDate = async (id) => {
  return await httpClient.get(`/mass_contract_modifications/${id}/get_date/`);
};

const setEight = async (id, data) => {
  return await httpClient.patch(
    `/mass_contract_modifications/${id}/set_eight/`,
    data,
  );
};

const saveDraft = async (id, data) => {
  return await httpClient.patch(
    `/mass_contract_modifications/${id}/save_draft/`,
    data,
  );
};

const getContractors = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/mass_contract_modifications/${query}/contractors_export/${
        search ? `?filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/mass_contract_modifications/${query}/contractors/?page[number]=${page}&page[size]=${pageSize}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

export {
  filter,
  get,
  remove,
  getCounters,
  getNewInfo,
  getTermsSelector,
  massContractSearch,
  getIdentifierSelector,
  post,
  patch,
  getContractors,
  getDate,
  setEight,
  saveDraft,
  getIMInfo,
  massContractSearchPayments,
  massContractSearchProducts,
};
